// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.dial_container_nzqCf {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.dial_dial-container_h3Hx6 {
    position: relative;
}

.dial_dial-face_SAVq7, .dial_dial-handle_Xa2Te, .dial_gauge_Q93ZG {
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
}

.dial_dial-face_SAVq7 {
    width: 100%;
}

.dial_dial-handle_Xa2Te {
    cursor: pointer;
    width: 40px;
    height: 40px;
    /* Use margin to make positioning via top/left easier */
    margin-left: calc(40px / -2);
    margin-top: calc(40px / -2);
}

.dial_gauge-path_MDfiK {
    fill: var(--looks-transparent);
    stroke: var(--looks-secondary);
    stroke-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/direction-picker/dial.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uDAAuD;IACvD,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,iBAAiB;AACrB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n    padding: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.dial-container {\n    position: relative;\n}\n\n.dial-face, .dial-handle, .gauge {\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: visible;\n}\n\n.dial-face {\n    width: 100%;\n}\n\n.dial-handle {\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    /* Use margin to make positioning via top/left easier */\n    margin-left: calc(40px / -2);\n    margin-top: calc(40px / -2);\n}\n\n.gauge-path {\n    fill: var(--looks-transparent);\n    stroke: var(--looks-secondary);\n    stroke-width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `dial_container_nzqCf`;
var _1 = `dial_dial-container_h3Hx6`;
export { _1 as "dial-container" };
export var dialContainer = `dial_dial-container_h3Hx6`;
var _2 = `dial_dial-face_SAVq7`;
export { _2 as "dial-face" };
export var dialFace = `dial_dial-face_SAVq7`;
var _3 = `dial_dial-handle_Xa2Te`;
export { _3 as "dial-handle" };
export var dialHandle = `dial_dial-handle_Xa2Te`;
export var gauge = `dial_gauge_Q93ZG`;
var _4 = `dial_gauge-path_MDfiK`;
export { _4 as "gauge-path" };
export var gaugePath = `dial_gauge-path_MDfiK`;
export default ___CSS_LOADER_EXPORT___;
